import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import I18n from "i18n-js";
import { RootState } from "app/store";
import Constants from "common/constant";
import { useScale } from "common/utils";
import { ProjectType } from "features/creator/types";
import { selectAllProjects } from "features/creator/slice";
import { Layout, Overlay } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: {
  back: () => void;
  next: () => void;
  close: () => void;
}) => {
  const { back, next, close } = props;
  const { width, height, scale } = useScale();
  const [panelRect, setPanelRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const projects = useSelector(selectAllProjects);
  const user = useSelector((state: RootState) => state.user.active);
  const userProjects = projects.filter(
    (project) =>
      project.author_uid === user.uid &&
      !project.deleted_at &&
      project.type === ProjectType.BASIC
  );
  const sortedProjects = userProjects.sort((a, b) =>
    dayjs(a.created_time) < dayjs(b.created_time) ? -1 : 1
  );

  useEffect(() => {
    setTimeout(() => {
      const panel = document.getElementById(
        `app-project-card-favorited-${
          sortedProjects[sortedProjects.length - 1].project_id
        }`
      );
      const rect = panel.getBoundingClientRect();
      setPanelRect({
        x: rect.x - 5 * scale,
        y: rect.y - 15 * scale,
        width: rect.width + 30 * scale,
        height: rect.width + 30 * scale,
      });
    }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scale]);

  return (
    <>
      <Overlay area={panelRect}>
        <></>
      </Overlay>

      <Layout
        transparent
        position={{
          x: width / 2 - 560 / 2 - 100,
          y: height / 2 - 336 / 2 - 250,
        }}
        back={back}
        next={next}
        close={close}
      >
        <Title activeStep={8} />

        <div className="flex-col-el items-start justify-center w-[312px]">
          <div className="flex-row-el flex-center gap-1">
            <img
              alt="お気に入りボタン"
              src={`${Constants.assetHost}/assets/images/icon_not_favorite.png`}
              className="w-[40px] h-[40px] object-contain"
            />

            <p className="text-body text-textcolor-black text-[22px] whitespace-pre text-center">
              は
            </p>
          </div>
          <p className="text-body text-textcolor-black text-[22px] whitespace-pre">
            {I18n.locale === "ja"
              ? "これまでにもらった\n「いいね」のかずです。"
              : "これまでにもらった\n「いいね」の数です。"}
          </p>
        </div>
      </Layout>
    </>
  );
};

export default Step;
